import { render, staticRenderFns } from "./FileUploadNew.vue?vue&type=template&id=c3a88fce&"
import script from "./FileUploadNew.vue?vue&type=script&lang=js&"
export * from "./FileUploadNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports